import { ShortUrl } from '@air/api';
import { ClipSource, CreateMultipartResponse } from '@air/api/types';
import { Upload, UploadPart } from '@air/redux-uploader';

import { reportErrorToBugsnag } from '~/utils/ErrorUtils';

interface AbortPublicLargeUploadParams {
  uploadUrlInfo: CreateMultipartResponse[0];
  shortBoardId: string;
}

export const sendAbortPublicMultipartUpload = async ({ uploadUrlInfo, shortBoardId }: AbortPublicLargeUploadParams) => {
  try {
    return await ShortUrl.abortMultipartUpload(shortBoardId, uploadUrlInfo.Key, uploadUrlInfo.UploadId);
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to abort public multipart upload board`,
      metadata: {
        data: {
          uploadUrlInfo,
        },
      },
    });
  }
};

interface SendPublicMultipartComplete {
  uploadUrlInfo: CreateMultipartResponse[0];
  uploadedParts: UploadPart[];
  shortBoardId: string;
}

export const sendPublicMultiPartUploadComplete = async ({
  uploadedParts,
  uploadUrlInfo,
  shortBoardId,
  uploadUrlInfo: { UploadId, Key },
}: SendPublicMultipartComplete) => {
  try {
    return await ShortUrl.completeMultipartUpload(shortBoardId, Key, UploadId, uploadedParts);
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to complete multipart upload`,
      metadata: {
        data: {
          uploadUrlInfo: uploadUrlInfo,
        },
      },
    });
  }
};

interface SendPublicCreateMultipartUploadParams {
  apiUploadData: Upload['apiUploadData'];
  sessionId: string;
  shortBoardId: string;
}

export const sendCreatePublicMultipartUpload = async ({
  shortBoardId,
  apiUploadData,
  sessionId,
}: SendPublicCreateMultipartUploadParams) => {
  try {
    const urlsInfo = await ShortUrl.createMultipartUploads(shortBoardId, [apiUploadData], {
      source: ClipSource.web,
      sessionId,
    });
    return urlsInfo[0];
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to create public multipart upload`,
      metadata: {
        data: {
          apiUploadData,
        },
      },
    });
  }
};

interface GetPublicUploadPartUrl {
  s3Info: CreateMultipartResponse[0];
  partNumber: number;
  shortBoardId: string;
}

export const fetchPublicPartUploadUrl = async ({ partNumber, shortBoardId, s3Info }: GetPublicUploadPartUrl) => {
  try {
    return await ShortUrl.getPartUploadUrl(shortBoardId, s3Info.Key, s3Info.UploadId, partNumber);
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to getPublicPartUploadUrl`,
      metadata: {
        data: {
          s3Info,
        },
      },
    });
  }
};
